
import { computed, defineComponent } from 'vue'
import { ColorEnum } from '../../enums'
import { UiTooltip } from '../keen-ui'
import { DefaultImage, EpbBadge, EpbText } from '../shared'

export default defineComponent({
  name: 'ToolingSettingCard',
  components: {
    EpbText,
    EpbBadge,
    DefaultImage,
    UiTooltip,
  },
  props: {
    title: { type: String, default: undefined },
    subtitle: { type: String, default: undefined },
    imageUrl: { type: String, default: undefined },
    position: { type: [Number, String], default: undefined },
    error: { type: String, default: undefined },
  },
  setup(props) {
    const baseClass = 'tooling-setting-card'

    const classes = computed(() => {
      return [baseClass, { [`${baseClass}__error`]: props.error }]
    })

    return {
      baseClass,
      classes,
      ColorEnum,
    }
  },
})
